import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { directTreasuryMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { DirectTreasuryAsset } from '.';

export const directTreasurySellTableHead: TableHeadItemRecurse[] = [
  { title: 'Produto', flex: 1.5 },
  { title: 'Quantidade disponível' },
  { title: 'Valor total' },
  { title: 'Quantidade a resgatar' },
  { title: 'Valor estimado' },
  { title: 'Disponível em conta' },
  { title: '' },
];

export const directTreasurySellConstants = {
  id: 'directTreasury',
  typeGetterId: 'directTreasurySell',
  title: 'Tesouro Direto',
  operationId: 2,
  operationName: 'Resgatar',
  operationType: 'sell' as OperationType,
  color: 'product.tesouro' as ColorTypes.Option,
  principalComponent: DirectTreasuryAsset,
  tableHead: directTreasurySellTableHead,
  hideTableHead: false,
  marketStatusSelector: directTreasuryMarketStatusQuery,
  hasFilters: false,
  mountFilters: (): FilterModalTypes.FilterType[] => [],
  hasCategories: false,
  categoriesLabel: '',
  categoriesField: '',
  mountCategories: () => [],
  captions: [] as AssetCaptionType[],
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  unleashFlag: Constant.UnleashDirectTreasurySellToggle,
  unleashFlagBatchTicket: Constant.UnleashBasketDirectTreasuryToggle,
  unleashFlagCustomers: Constant.UnleashCustomersDirectTreasuryToggle,
} as const;
